<template>
    <div v-if="siloData.user.id !== 0 && readyToUse === true" id="hm" class="hm c" :data-is-covered="isCovered" :data-processing="processing">
        <div class="hm__wrap c c--content--pad r pad--h">

            <div class="header bg-color--dark">
                <div class="header__wrap r">
                    <div class="header__text">
                        <Icon name="sp/spinepal-wordmark" />
                    </div>
                    <div class="header__logo">
                        <Icon name="sp/spinepal-logomark" />
                    </div>
                </div>
            </div>

            <div class="main r">

                <!-- Topic selector -->
                <div class="topics r r--justify-center r--halign-center"
                    :class="modules === null ? 'loading' : 'active'">
                    <div class="topics__menu r">

                        <template v-if="modules !== null">
                            <button v-for="(module, index) in modules" class="topics__menu__button r" :key="index"
                                :data-status="getStatus(index)" :data-locked="isLocked(index)" @click="launchTopic(module.slug)">
                                <div class="topics__menu__button__icon" :class="module.topic_image ? 'topics__menu__button__icon--image' : 'topics__menu__button__icon--blank'">
                                    <Icon v-if="module.topic_image" :name="`sp/topic/${module.topic_image}`" />
                                </div>
                                <div class="topics__menu__button__title type--h3--default type--h3--default--home" v-html="module.title"></div>
                                <div class="topics__menu__button__status">
                                    <Icon name="sp/ui/status-complete" />
                                </div>
                            </button>
                        </template>

                        <template v-else>
                            <button v-for="n in 6" class="topics__menu__button r" :key="n">
                                <div class="topics__menu__button__icon topics__menu__button__icon--blank"></div>
                                <div class="topics__menu__button__title type--h3--default">Loading</div>
                            </button>
                        </template>

                    </div>
                </div>

            </div>
            <div class="other r">
                <button class="other__button other__button--goals" :data-locked="this.siloData.user.stats.goals_is_locked" @click="$emit('updateState', 'goals');">
                    <div class="other__button__icon">
                        <Icon name="sp/topic/my-goal-card" />
                    </div>
                    <span class="other__button__text type--h3--default">My Goals</span>
                </button>
                <button class="other__button other__button--exercises" :data-locked="this.siloData.user.stats.exercises_is_locked" @click="launchTopic('relaxation', { title: 'Exercises', hide_description: true, hide_status: true })">
                    <div class="other__button__icon">
                        <Icon name="sp/topic/exercises-card" />
                    </div>
                    <span class="other__button__text type--h3--default">Exercises</span>
                </button>
            </div>
            <div class="footer bg-color--dark">
                <div class="footer__wrap c c--content--pad r">
                    <button v-if="this.siloData.user.role === 'administrator' && this.siloData.user.id === 1" @click="$emit('updateState', 'checkin');" class="btn--text">
                        Checkin
                    </button>
                    <a v-if="this.siloData.user.role === 'administrator' || this.siloData.user.role === 'program_administrator'" href="/reporting" target="_blank">Reporting</a>
                    <button @click="openModalLogout" class="btn--text">Logout</button>
                    <div class="footer__version">v.{{ this.siloData.user.app.version }}</div>
                    <button @click="toggleNs" class="btn--text">Settings</button>
                </div>
            </div>
            <div style="display:none;">
                <div class="logout-modal">
                    <div class="logout-modal__wrap r v--15">
                        <h2 class="type--h3--default">Are you sure you want to logout?</h2>
                        <div class="btn-row r v--10">
                            <button @click="doLogout" class="btn btn--solid">Yes</button>
                            <button onclick="modal.close();" class="btn btn--solid">No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display:none;">
                <div class="ns">
                    <div class="ns__wrap">
                        <Pushmanager :instance="null" :active="show_ns" :siloData="siloData"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@c/Icon.vue";
import AwardBadge from "@c/AwardBadge.vue";
import Pushmanager from "@c/panels/Pushmanager.vue";
const axios = require('axios');

//import Vue, { TrackOpTypes } from 'vue'

export default {
    components: {
        Icon,
        AwardBadge,
        Pushmanager,
    },
    data() {
        return {
            modules: null,
            modal_class: 'notice-centered',
            processing: false,
            has_been_seen: false,       // true once onFirstLoad() has been checked at least once this mount
            processing_landing: false, // guards against a single landing firing the routine twice (watcher + mounted() race)
            show_ns: false, // reflects whether the push-settings modal is actually open — see toggleNs()
            subscribe_check_count: 0,
        }
    },
    props: {
        appState: String,
        siloData: Object,
        readyToUse: Boolean,
    },
    computed: {
        isCovered() {
            return this.appState !== 'home' ? 'true' : 'false';
        }
    },
    async mounted() {
        window.home = this;
        await this.getModules();

        // The parent's v-if="canActivateHomeScreen" guarantees readyToUse
        // is already true whenever this component exists, so we don't need
        // to watch for that. But appState may already be 'home' by the time
        // we mount (e.g. page refresh) — the watcher below can't catch a
        // transition that happened before we existed, so we check directly here.
        if (this.appState === 'home') {
            this.onLandOnHome();
        }
    },
    watch: {
        // Determine status of module here
        appState() {
            if (this.siloData.user.id !== 0 && this.appState === 'home') {
                this.postPageView();
                this.onLandOnHome();
            }
        }
        // Note: previously there was also a `readyToUse()` watcher here.
        // It's been removed — since this component only ever exists once
        // readyToUse is already true (see the parent's v-if), that watcher
        // could structurally never fire on a fresh mount and was dead code.
    },
    methods: {
        // Single entry point for "user has landed on the home page."
        // Runs every time appState transitions to 'home', and also on
        // initial mount if we're already home. Replaces the old
        // manualLoadChecks() method, which used to be called externally
        // (from UserSorter via window.home) — that's no longer needed since
        // this component now detects its own landing.
        onLandOnHome() {
            if (this.processing_landing) return;
            this.processing_landing = true;

            if (this.has_been_seen === false) {
                this.has_been_seen = true;
                this.onFirstLoad(); // still internally guarded by has_landed_on_homepage
            }

            // These should run on every landing, not just the first
            this.subscribe_check_count = 0; // fresh retry budget each landing
            this.checkForAssessment();
            this.subscribeToNotifications();

            this.$nextTick(() => { this.processing_landing = false; });
        },
        // Do this on the first time the user lands on the home page
        async onFirstLoad() {
            console.log('homescreen: doing on first load');

            if (this.siloData.user.stats.has_landed_on_homepage === true || this.siloData.user.stats.has_landed_on_homepage === 'true') {
                console.log('USER HAS ALREADY VIEWED HOMEPAGE ONCE');
                return;
            }

            let data = [];
            let key = "meta_us_has_landed_on_homepage";
            let value = "true";
            let data_item = {
                key,
                value
            }
            data.push(data_item);
            console.log('homescreen: attempting to post this data:', data);
            await axios.post(this.siloData.urls.postuserdata, data).then(response => {
                this.$emit('refreshData');
                console.log('homescreen: posted viewed homescreen once');
            });

            this.checkForWelcomeCompletion();
        },
        async checkForWelcomeCompletion() {
            console.log('homescreen: checking for page completion');

            if (this.siloData.user.progress[0].status === "complete") {
                console.log('homescreen: user has completed topic 1, show home');
                return;
            }

            console.log('homescreen: must complete topic 1');

            console.log('homescreen: launching topic 1');
            // Need to toss in a minor delay here otherwise the transition is jarring
            setTimeout(()=>{
                console.log('homescreen: topic 1 launched');
                this.launchTopic('welcome');
            }, 1500);
        },
        async checkForAssessment() {

            console.log('should we show checkin?:', this.siloData.user.stats.show_checkin);

            if (this.siloData.user.stats.show_checkin === false) { console.log('homescreen: assessment check: not ready for checkin'); return; }

            // Give it a sec becuase otherwise it just pops up and is a bit jarring
            setTimeout(() => {
                // Fire the checkin
                this.$emit('updateState', 'checkin');


                // Post last checkin seen time (needs to be reviewed)
                console.log('home screen: assessment check: posting datetime of last seen');

                // Post the time we saw the check in
                // NOTE: THIS IS NOT FIRING????
                axios.post(this.siloData.urls.postdatetime, { key: 'meta_last_checkin_seen_date' }).then((result) => {
                    this.$emit('refreshData');
                    console.log('should we show checkin check after showing it?:', this.siloData.user.stats.show_checkin);
                }).catch((reason) => {
                    console.log(reason);
                    console.log('check in time didnt post for some reason!!!!');
                });

                /*
                // Check to see if the user has seen the checkin and if not set it to true
                if (this.siloData.user.stats.has_seen_checkin === false) {
                    let data = [];
                    let key = `meta_has_seen_checkin`;
                    let value = true;
                    let data_status = {
                        key,
                        value
                    }
                    data.push(data_status);
                    axios.post(this.siloData.urls.postuserdata, data);
                }
                */

            }, 1000);
        },
        subscribeToNotifications() {
            console.log('*** home screen: subscribing to notifications');
            if (this.subscribe_check_count >= 10) { return; }
            // When this is called, it should already have access to window.notifications
            if (window.notifications === undefined || window.notifications.Notifications === undefined || this.siloData.user.id === 0) {
                console.log('*** home screen: notifications object not found or user not signed in yet');

                this.subscribe_check_count++;

                setTimeout(() => {
                    this.subscribeToNotifications();
                }, 1000);
            } else {
                console.log('*** home screen new: notifications object found, logging in user');
                window.pusher.loginUser();
            }
        },
        // index: this is actually a slug
        // args: an array of data we pass to the topic to overwrite specific variables
        launchTopic(index, args = null) {
            console.log('homescreen: launching topic', index);
            // NOTE: Add some kind of check here to make sure a topic isn't already open?
            window.topicmenu.getTopicMenu(index, args);
        },
        postPageView() {
            let data = {
                type: 'home'
            };
            window.events.postPageView(data);
        },
        getStatus(index) {
            // take the index, which will be the module number
            // based on that, get look for the coorelated index in siloData.user.
            return this.siloData.user.progress[index].status ? this.siloData.user.progress[index].status : "open";
        },
        isLocked(index) {
            // By default each module is locked
            // let returned = "true";

            // If this is the first module unlock it
            if (index === 0) {
                return "false";
            } else {
                // If this is a module greater than 1
                // Look at the user's status table
                // and check the previous index to see if it is completed
                let previous_module_status = this.siloData.user.progress[index - 1].status;

                // If the previous module is complete, this module is unlocked
                if (previous_module_status === "complete") {
                    return "false"
                } else {
                    return "true"
                }
            }

            //return returned;
        },
        async getModules() {
            this.processing = true;
            // TODO: Rewrite this once we figure out the structure of the program
            axios(this.siloData.urls.getmodules).then((result) => {
                console.log(result);
                this.modules = result.data;
                this.processing = false;
            }).catch((reason) => {
                console.log(reason);
                this.processing = false;
            });
        },
        getModuleIconName(order) {
            return "icon-module-" + order;
        },
        // There's definitly a better way to do this
        openModule(id) {
            // We need to clear out any query strings, otherwise when we open the URL
            // it will make the modal act strange
            this.clearQueryStrings();
            window.moduleloader.open(id);
        },
        clearQueryStrings() {
            // Get the current url without query strings
            let cleanUrl = window.location.href.replace(window.location.search, '');
            // Update the URL without reloading
            window.history.replaceState({}, window.title, cleanUrl);
        },
        // Get number of completed modules
        // MAYBE MOVE THIS TO PHP
        getCompleted() {
            let returned = 0;
            this.modules.forEach((module, index) => {
                let status = this.siloData.user.progress[index].status;
                if (status === "complete") {
                    returned++;
                }
            });
            return returned;
        },
        getDaysTracked() {
            return this.siloData.user.stats.days_tracked;
        },
        toggleNs() {
            const modalArgs = {
                button: false,
                message_is_element: true,
                message: '.ns',
                additional_classes:'notice-centered-wide',
            };
            window.modal.set(modalArgs);

            // Reflect the panel's real open state, instead of the
            // previous hardcoded :active="true" on Pushmanager, which
            // meant that prop never actually tracked whether this modal
            // was on screen at all.
            this.show_ns = true;

            // Trigger a fresh check directly on every open, rather than
            // relying solely on Pushmanager's active watcher — a watcher
            // only catches a genuine false->true transition, so it
            // wouldn't refire on a second or third open once show_ns is
            // already true. This guarantees the panel re-verifies state
            // (catching anything that changed since it was last open,
            // e.g. subscribing via the homescreen's automatic prompt
            // while this modal was never opened) every single time.
            window.notificationsSettings?.checkNotifications();
        },
        openModalLogout() {
            modal.set(
                {
                    button: false,
                    message_is_element: true,
                    message: '.logout-modal',
                    additional_classes: 'notice-centered'
                }
            );
        },
        doLogout() {
            this.$emit('logout');
            modal.close();
        },
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

#hm {
    padding-top: env(safe-area-inset-top);
    //max-width: rem(405px);
    padding-bottom: rem(60px);
    height: 100vh;
    background-color: var(--color-sp-green);
    transition: all 0.5s;
    &[data-is-covered="false"] {
        .hm__wrap {
            opacity: 1;
            transform: scale(1);
        }
    }
    &[data-is-covered="true"] {
        background-color: var(--color-sp-green-dark);
        .hm__wrap {
            opacity: 0.25;
            transform: scale(0.95);
        }
    }
    &[data-processing="true"] {
        .topics, .other {
            //opacity: 0;
        }

        .topics__menu__button {
            pointer-events: none;
            opacity: 0.5;
            .topics__menu__button__status {
                opacity: 0;
            }
            .topics__menu__button__title {
                opacity: 0;
            }
        }

        .other__button {
            pointer-events: none;
            opacity: 0.5;
            .other__button__text {
                opacity: 0;
            }
        }
        /* Control timing here */
        .header__logo {
            svg path {
                animation-name: fadePulse;
                animation-duration: 2s;
                animation-timing-function: ease-in-out;
                animation-iteration-count: infinite;
                opacity: 1;
            }
        }
    }
    &[data-processing="false"] {
        .topics, .other {

        }
    }
}

.header__logo {
    svg path {
        opacity: 1;
    }
}

/* Sequential delays */
.header__logo {
    svg path:nth-of-type(1) { animation-delay: 0s; }
    svg path:nth-of-type(2) { animation-delay: 0.15s; }
    svg path:nth-of-type(3) { animation-delay: 0.3s; }
    svg path:nth-of-type(4) { animation-delay: 0.45s; }
    svg path:nth-of-type(5) { animation-delay: 0.6s; }
    svg path:nth-of-type(6) { animation-delay: 0.75s; }
    svg path:nth-of-type(7) { animation-delay: 0.9s; }
    svg path:nth-of-type(8) { animation-delay: 1.05s; }
    svg path:nth-of-type(9) { animation-delay: 1.2s; }
}


.hm__wrap {
    transition: all 0.5s;
}

/* Header ------------------------------------------------------ */

.header {
    z-index: 1;
    padding-top: rem(30px);
}

.header__wrap {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header__text {

}

.header__logo {
    display: block;
    width: rem(83px);
    height: rem(25px);
}

/* Main ------------------------------------------------------ */

.main {
    z-index: 2;
}

.topics {
    z-index: 2;
    transition: all 0.15s;
}

/* New ------------------------------------------------------ */

.topics__menu {
    padding-top: rem(30px);
    gap: rem(10px);
}

.topics__menu__button {
    background-color: var(--color-offwhite);
    padding: rem(6px);
    width: 100%;
    border-radius: rem(5px);
    flex-direction: row;
    align-items: center;
    gap: rem(20.5px);
    transition: all 0.15s;
    @media screen and (max-width: 380px) {
        gap: rem(15px);
    }
    &:hover, &:focus {
        outline: 2px solid #26ae7a !important;
        background-color: var(--color-white);
    }
    &[data-status="open"] {

    }
    &[data-locked="true"] {
        opacity: 0.5 !important;
        pointer-events: none !important;
    }
    &[data-status="complete"] {
        .topics__menu__button__status {
            opacity: 1;
            transform: scale(1) rotate(0deg);
        }
    }
}

.topics__menu__button__icon {
    display: flex;
    flex-shrink: 0;
    width: rem(58px);
    height: 100%;
    aspect-ratio: 58/50;
    border-radius: rem(5px);
    &--blank {
        background-color: #eee;
    }
    &--image {
        svg {
            width: 100%;
            height: auto;
        }
    }
}

.topics__menu__button__title {}

.topics__menu__button__status {
    width: rem(27px);
    height: rem(26px);
    display: block;
    position: absolute;
    right: rem(15px);
    opacity: 0;
    transform: scale(0) rotate(180deg);
    transition: all 0.3s 0.1s;
    overflow: visible;
    svg {
        width: 100%;
        height: auto;
    }
}

/* Other buttons ------------------------------------------------------ */

.other {
    margin-top: rem(20px);
    gap: rem(19px);
    flex-direction: row;
    transition: all 0.15s;
}

.other__button {
    display: flex;
    height: rem(84px);
    width: 100%;
    padding: rem(16px) rem(19px) rem(16px);
    background-color: var(--color-offwhite);
    border-radius: rem(10px);
    overflow: hidden;
    transition: all 0.15s;
    &:hover, &:focus {
        outline: 2px solid #26ae7a !important;
        background-color: var(--color-white);
    }
    &[data-locked="true"] {
        opacity: 0.5 !important;
        pointer-events: none !important;
    }
}

.other__button__icon {
    position: absolute;
    right: rem(-12px);
    bottom: rem(-12px);
    pointer-events: none;
    display: block;
    width: rem(73px);
    height: rem(73px);
    svg {
        width: 100%;
        height: auto;
    }
}

/* Temp footer ------------------------------------------------------ */
</style>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.footer {
    padding-top: rem(30px);
    color: var(--color-sp-teal) !important;
}
.footer__wrap {
    justify-content: center;
    flex-direction: row;
    align-items: center;
    font-size: rem(13px);
    > * + * {
        &:before {
            content: "|";
            margin-inline: rem(10px) rem(10px);
        }
    }
    .footer__version {
        display: flex;
    }
    button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        //gap: rem(10px);
        &:hover, &:focus {
            text-decoration: underline;
        }
    }
}

/* NS ------------------------------------------------------ */

.ns {
    margin-top: 40px;
}

.ns__wrap {
    background-color: #fff;
}
</style>
